import type { IconProps } from './IconsTypes'

export const ClickToPayIcon = ({
  width = 92,
  height = 29,
  viewBox = '0 0 92 29',
  color = '#0071CE',
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12041_11456)">
      <mask
        id="mask0_12041_11456"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="46"
        height="29"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H45.0798V29H0V0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_12041_11456)">
        <path
          d="M28.3342 3.06104C28.2519 2.92492 28.142 2.80832 28.0118 2.7191C27.8815 2.62989 27.734 2.57013 27.5792 2.54384C27.4243 2.51756 27.2658 2.52536 27.1141 2.56673C26.9625 2.6081 26.8214 2.68206 26.7002 2.78365C26.579 2.88523 26.4806 3.01209 26.4117 3.15565C26.3427 3.29921 26.3048 3.45614 26.3004 3.61589C26.2961 3.77563 26.3254 3.93447 26.3864 4.0817C26.4475 4.22893 26.5388 4.36113 26.6542 4.46941L34.9211 14.7243L26.7461 24.7844H23.2144L30.9402 15.5859C30.9452 15.5803 30.9497 15.5746 30.9545 15.5689L30.9561 15.5695C31.1529 15.3498 31.262 15.0633 31.262 14.766C31.262 14.4687 31.1529 14.1821 30.9561 13.9624L30.9545 13.9628C30.9497 13.9572 30.9452 13.9515 30.9402 13.9459L21.7147 3.07877L21.7084 3.07118C21.6118 2.9039 21.474 2.7652 21.3086 2.66879C21.1432 2.57238 20.956 2.52161 20.7654 2.52151H14.286C14.1416 2.52188 13.9987 2.55119 13.8655 2.60779C13.7322 2.66438 13.6112 2.74715 13.5094 2.85135C13.4075 2.95555 13.3268 3.07916 13.2719 3.2151C13.217 3.35105 13.189 3.49667 13.1894 3.64366C13.177 3.82648 13.2209 4.00867 13.3149 4.16494L21.9014 14.8076L14.5832 23.7916C14.3748 24.0767 14.1068 24.3112 13.7984 24.4779C13.4901 24.6446 13.1491 24.7395 12.8004 24.7556H4.02683C3.74088 24.7582 3.45729 24.7028 3.19257 24.5927C2.92785 24.4826 2.68729 24.32 2.48493 24.1143C2.28256 23.9086 2.12242 23.664 2.01385 23.3947C1.90528 23.1254 1.85044 22.8368 1.85252 22.5457V6.9722C1.87629 6.38715 2.11629 5.83284 2.52446 5.42029C2.93263 5.00773 3.47883 4.76739 4.05368 4.7474H9.52456C9.66953 4.75518 9.81449 4.73205 9.95017 4.67951C10.0859 4.62696 10.2093 4.54616 10.3125 4.44226C10.4157 4.33836 10.4965 4.21366 10.5497 4.07614C10.6028 3.93862 10.6272 3.79132 10.6212 3.64366C10.628 3.49397 10.6044 3.34447 10.552 3.20443C10.4996 3.0644 10.4195 2.93682 10.3167 2.82961C10.2139 2.72239 10.0905 2.63783 9.95424 2.58118C9.81797 2.52453 9.67172 2.49698 9.52456 2.50026L4.00038 2.5226C2.84735 2.52342 1.74178 2.99007 0.926457 3.82007C0.11113 4.65007 -0.347298 5.77554 -0.348145 6.94936V22.5457C-0.321095 23.7132 0.145065 24.8256 0.954183 25.6535C1.7633 26.4814 2.85367 26.9617 4.00038 26.9951H12.7715C13.1796 26.9955 13.5858 26.9377 13.9782 26.8233C14.03 26.8082 14.0811 26.7923 14.1312 26.7757C14.9316 26.5069 15.6471 26.0256 16.2038 25.3814L24.4397 15.5598C24.6393 15.3439 24.7511 15.0589 24.7523 14.7624C24.7535 14.4659 24.6441 14.18 24.4462 13.9624L24.4446 13.9628C24.4397 13.9572 24.4352 13.9515 24.4304 13.9459L16.6399 4.7474H20.2362L28.3775 14.766L19.8103 25.3405C19.8075 25.3437 19.8128 25.3527 19.8249 25.367C19.7372 25.5376 19.6942 25.7284 19.6998 25.9209C19.7055 26.1134 19.7596 26.3012 19.8571 26.4662C19.9547 26.6312 20.0922 26.768 20.2566 26.8633C20.421 26.9586 20.6067 27.0092 20.7958 27.0104H27.2752C27.4658 27.0102 27.6531 26.9594 27.8185 26.863C27.9839 26.7665 28.1217 26.6278 28.2184 26.4606L28.2245 26.4531L37.4502 15.5859L37.4644 15.5689L37.466 15.5695C37.6639 15.3519 37.7733 15.0659 37.7721 14.7694C37.7709 14.4729 37.6592 14.1879 37.4596 13.9719L28.3342 3.06104Z"
          fill="black"
        />
      </g>
    </g>
    <path d="M44 1.5L44 27.5" stroke="black" strokeWidth="1.17799" />
    <rect x="50" width="42" height="29" rx="2.41775" fill="black" />
    <path
      d="M74.9521 7.77832H67.6541V20.9828H74.9521V7.77832Z"
      fill="#FF5F00"
    />
    <path
      d="M68.1172 14.381C68.1172 11.8148 69.2988 9.36517 71.2913 7.77877C67.677 4.90926 62.4177 5.53915 59.568 9.20187C56.7414 12.8412 57.367 18.1137 61.0045 20.9832C64.0395 23.3861 68.2794 23.3861 71.3144 20.9832C69.2988 19.3968 68.1172 16.9472 68.1172 14.381Z"
      fill="#EB001B"
    />
    <path
      d="M84.7985 14.381C84.7985 19.0235 81.0684 22.7796 76.4579 22.7796C74.5812 22.7796 72.7741 22.1497 71.3145 20.9832C74.9287 18.1137 75.5543 12.8413 72.7046 9.17854C72.2875 8.66529 71.8242 8.17537 71.3145 7.77877C74.9287 4.90926 80.188 5.53915 83.0145 9.20187C84.173 10.6716 84.7985 12.4913 84.7985 14.381Z"
      fill="#F79E1B"
    />
    <defs>
      <clipPath id="clip0_12041_11456">
        <rect width="38" height="29" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
